module.exports = __webpack_public_path__ + "img/logo-company.f14824b2.png";